import Typography, { TypographyVariant } from '@ben/orion/typography';
import type { IModularBenefitDetail } from '@ben/shared/types/columbia';
import { Controller, type Control } from 'react-hook-form';
import styled, { css } from 'styled-components';
import useSetDirtyValue from '../hooks/use-set-dirty-value';
import ModelMultiDropdown from '../model-select/model-multi-dropdown';

interface LifeEventsProps {
  control: Control<IModularBenefitDetail>;
}

const LifeEvents = ({ control }: LifeEventsProps) => {
  const setDirtyValue = useSetDirtyValue<IModularBenefitDetail>();
  return (
    <Container>
      <HeaderContainer>
        <Typography variant={TypographyVariant.bodyLg2}>Life events</Typography>
        <Typography variant={TypographyVariant.bodyMd1}>
          Allow employees to request to open the config window upon a life event
        </Typography>
      </HeaderContainer>
      <Controller
        name="lifeEvents"
        control={control}
        render={({ field }) => {
          const { value, ref } = field;
          return (
            <ModelMultiDropdown
              ref={ref}
              name="Select eligible life events (optional)"
              defaultValue={value ?? []}
              apiName="life-events"
              width="240px"
              onChange={(values) => setDirtyValue('lifeEvents', values)}
            />
          );
        }}
      />
    </Container>
  );
};

export default LifeEvents;

const HeaderContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.5)};
  `}
`;

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `}
`;
